import { focusDeepWithin } from "@otto-ec/otto-components-utils/utils/focus/focusDeepWithin";
import type { CustomElement } from "./utils";
import { completeElementInit, registerElementInit } from "./performance";
import { addInstance } from "./telemetry";
import { cleanUpFalsyBooleanAttributes } from "./cleanup";

export const extendElementBase = (Base: CustomElement): CustomElement =>
  class extends Base {
    constructor(...args: unknown[]) {
      super(...args);

      /*                               */
      addInstance(this.tagName);
      /*                                         */
      registerElementInit(this);
    }

    async connectedCallback(): Promise<void> {
      /*                                        */
      /*                                     */
      if (!this.shadowRoot) {
        this.$$shadowRoot = this.attachShadow({ mode: "open" });
      }

      //
      /*                                                   */
      cleanUpFalsyBooleanAttributes(this);

      /*                                                                          */
      const res = await super.connectedCallback();

      /*                                                   */
      completeElementInit(this);

      /*                                                                         */
      return res;
    }

    /*                                      */
    focus(): void {
      /*                            */
      /*                                                                    */
      /*                                                            */
      /*                                                                                     */
      /*                                                                                                                                                      */
      /*                                                                                                    */
      /*                                                                                                                */
      focusDeepWithin(this);
    }
  };
